import { createContext, useContext } from 'react';

const LayoutContext = createContext({
  isCollapse: false,
});

export const LayoutProvider = LayoutContext.Provider;

export const useLayoutContext = () => useContext(LayoutContext);
